import { ModuleModel } from '../../module.model.interface';
import { ProfileModel } from '../../profile/model/profile.model';

export enum InspectionState {
  Created,
  Sent,
  Approved,
  Disputed,
  Closed,
  Forced
}

export class InspectionStateDetail {
  public id: string;
  public name: string;

  constructor(options?: {
    id: string,
    name: string,
  }) {

    if (options) {
      this.id = options.id;
      this.name = options.name;
    }
  }
}

export const InspectionStateMap = {
  Created: new InspectionStateDetail({ id: 'Created', name: 'Létrehozva' }),
  Sent: new InspectionStateDetail({ id: 'Sent', name: 'Elküldve' }),
  Approved: new InspectionStateDetail({ id: 'Approved', name: 'Elfogadva' }),
  Disputed: new InspectionStateDetail({ id: 'Disputed', name: 'Vitatva' }),
  Closed: new InspectionStateDetail({ id: 'Closed', name: 'Lezárva' }),
  Forced: new InspectionStateDetail({ id: 'Forced', name: 'Lezárva (Forced)' }),
};

export const InspectionStateList: InspectionStateDetail[] = [
  InspectionStateMap.Created,
  InspectionStateMap.Sent,
  InspectionStateMap.Approved,
  InspectionStateMap.Disputed,
  InspectionStateMap.Closed,
  InspectionStateMap.Forced,
];

export class InspectionDescriptor implements ModuleModel {
  public discriminator = 'InspectionDescriptor';

  public id: string;
  public clerkId: string;
  public createdOn: Date;
  public inspectionState: InspectionState;

  public href: string;
  public modified: Date;
  public deleted: Date;

  public clerkDetail: ProfileModel;
  public clerkName: string;

  constructor(options?: {
    id: string;
    clerkId: string;
    createdOn: Date;
    inspectionState: InspectionState;
  
    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;
      this.clerkId = options.clerkId;
      this.createdOn = options.createdOn;
      this.inspectionState = options.inspectionState;

      this.href = options.href;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/inspection/model/inspection.ts